import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FilterQuery } from '@core/types';
import { map } from 'rxjs/operators';
import { GroupTasksList, TaskEntity } from '@core/entities';

@Injectable({
  providedIn: 'root',
})
export class GroupTasksService {
  private readonly _http = inject(HttpClient);

  private readonly _apiUrl = environment.apiUrl;

  find(groupId: any, queryParams?: FilterQuery): Observable<GroupTasksList> {
    return this._http.get<any>(`${this._apiUrl}/getGroupTask/ByGroupId/${groupId}`, { params: queryParams });
  }

  get(taskId: any): Observable<TaskEntity> {
    return this._http.get<any>(`${this._apiUrl}/get-task-by-id/${taskId}`).pipe(map((response) => response.result[0]));
  }

  updateStatus(subTaskId: any, uncomplete?: FilterQuery): Observable<any> {
    // Create HttpParams object to handle query parameters
    const params = new HttpParams({ fromObject: uncomplete });

    return this._http.get<any>(`${this._apiUrl}/complete-subtask-by-id/${subTaskId}`, { params });
  }
}
